import React, { useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import { getCurrentDateFormatted, romanNum } from "../../../utilities/Utils";
import SweetAlert from "react-bootstrap-sweetalert";
import { Button, Modal, Spinner } from "react-bootstrap";
import Disposisi from "../../../utilities/Disposisi";
import UserService from "../../../services/user/UserService";
import { AsyncPaginate } from "react-select-async-paginate";
import PbUmkuService from "../../../services/pbumku/PbumkuService";

const ModalSpp = ({ showAddPenugasan, handleCloseAddPenugasan, dataDisposisi, datappm, reloadList }) => {

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    const [showConfirmPenugasan, setShowConfirmPenugasan] = useState(false)
    const handleCloseConfirmPenugasan = () => setShowConfirmPenugasan(false)
    const [showPenugasanSuccess, setShowPenugasanSuccess] = useState(false)
    const [showPenugasanFailed, setShowPenugasanFailed] = useState(false)
    const [rowPenugasan, setRowPenugasan] = useState(null)

    const [valuePejabatOpt, setValuePejabatOpt] = useState(null)
    const [valuePegawaiOpt, setValuePegawaiOpt] = useState(null)

    const [loadingSave, setLoadingSave] = useState(false)

    // const [selectedVerLapOpt, setSelectedVerLapOpt] = useState(null)

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    async function loadOptionPejabatTtd(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPegawai(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangePejabatOpt = e => {
        setValuePejabatOpt(e)
    }

    const onChangePegawaiOpt = e => {
        setValuePegawaiOpt(e)
        // console.log(e)
    }

    const SavePenugasan = (dataDisposisi) => {
        setShowConfirmPenugasan(true)
        setRowPenugasan(dataDisposisi)
    }

    const handleClickPenugasan = async () => {
        setLoadingSave(true)
        try {
            let idDispLap = ''
            let kodeStatus = ''
            let noSuratTugasTemp = datappm.kdUpt + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + Math.floor(100000 + Math.random() * 900000)
            let noSuratTugas = ''
            let jsonOrgano = ''
            let idDispDraftHc = ''
            let jnsPenomoran = ''
            switch (rowPenugasan.idDisposisi) {
                case 2:
                    idDispLap = 3
                    kodeStatus = '021'
                    // noSuratTugas = 'P26/E/' + noSuratTugasTemp
                    jnsPenomoran = 'PPM_SPT_EP'
                    break;
                case 5:
                    idDispLap = 8
                    kodeStatus = '022'
                    // noSuratTugas = 'P29/E/' + noSuratTugasTemp
                    jnsPenomoran = 'PPM_SPT_ET'
                    // if (selectedVerLapOpt === 1) {
                    //     jsonOrgano = { idDisposisi: 6, nomorAju: datappm.nomorAju }
                    // }
                    break;
                case 6:
                    idDispLap = 7
                    kodeStatus = '023'
                    noSuratTugas = 'P-Org/E/' + noSuratTugasTemp
                    break;
                case 4:
                    idDispDraftHc = 9
                    // noSuratTugas = 'P25/E/' + noSuratTugasTemp
                    kodeStatus = '026'
                    jnsPenomoran = 'PPM_SPT_DR'
                    break;
                default:
                    break;
            }
            const respNomor = await pbumkuService.ambilNomorService(jnsPenomoran, datappm.kdUpt, currentYear, localStorage.getItem('username'))
            noSuratTugas = respNomor.data.uraianPusat + '/' + datappm.kdUpt + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut
            let jsonSpp = { ...rowPenugasan, noTugas: noSuratTugas, tglTugas: getCurrentDateFormatted(), nipPejabat: valuePejabatOpt.nip, nmPejabat: valuePejabatOpt.nama, createdBy: localStorage.getItem("userId"), createdAt: new Date() }
            const _resSpp = await transaksiService.addPenugasan(jsonSpp)
            if (_resSpp.data.kode === '200') {
                valuePegawaiOpt.map(async (pegawai) => {
                    let jsonSppTugas = {
                        nomorAju: datappm.nomorAju,
                        noTugas: noSuratTugas,
                        nipPetugas: pegawai.nip,
                        namaPetugas: pegawai.nama
                    }
                    // console.log(jsonSppTugas)
                    await transaksiService.addPenugasanDetil(jsonSppTugas)
                })

                if (idDispLap !== '') {
                    let jsonLap = { idDisposisi: idDispLap, nomorAju: datappm.nomorAju }
                    await transaksiService.addPenugasan(jsonLap)

                    let dataPpm = { ...datappm, status: kodeStatus }
                    await transaksiService.addPpm(dataPpm)
                }

                if (idDispDraftHc !== '') {
                    let jsonDraftHC = { idDisposisi: idDispDraftHc, nomorAju: datappm.nomorAju }
                    const resDraft = await transaksiService.addPenugasan(jsonDraftHC)
                    if (resDraft.data.kode === '200') {
                        // let jsonPnbp = { idDisposisi: '10', nomorAju: datappm.nomorAju }
                        // await transaksiService.addPenugasan(jsonPnbp)
                        // let jsonHc = { idDisposisi: '11', nomorAju: datappm.nomorAju }
                        // await transaksiService.addPenugasan(jsonHc)
                        let dataPpm = { ...datappm, status: kodeStatus }
                        await transaksiService.addPpm(dataPpm)
                    }
                }

                if (jsonOrgano !== '') {
                    await transaksiService.addPenugasan(jsonOrgano)
                }
                setShowPenugasanSuccess(true)
                setShowConfirmPenugasan(false)
            }
        } catch (error) {
            console.log(error)
            setShowPenugasanFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickPenugasanSuccess = () => {
        setShowPenugasanSuccess(false)
        // window.location.reload()
        reloadList(0, 10)
    }

    const handleClickPenugasanFailed = () => {
        setShowPenugasanFailed(false)
    }

    return (
        <>
            <Modal show={showAddPenugasan}
                onHide={handleCloseAddPenugasan}
                backdrop='static'
                keyboard={false}
                size="xl"
                centered
            >
                <Modal.Header>
                    <h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Pejabat Penandatangan</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPejabatTtd}
                                value={valuePejabatOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePejabatOpt}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Petugas</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPegawai}
                                value={valuePegawaiOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePegawaiOpt}
                                isMulti
                            />
                        </div>
                    </div>
                    {
                        // dataDisposisi.idDisposisi === 5 &&
                        // <>
                        //     <div className="row mb-3">
                        //         <label className="col-sm-2 col-form-label-sm">Verifikasi Lapangan</label>
                        //         <div className="col-sm-4">
                        //             {/* <select className="form-select">
                        //                 <option value={1}>Onsite</option>
                        //                 <option value={2}>Online</option>
                        //             </select> */}
                        //             <Form.Select value={selectedVerLapOpt} onChange={handleSelectVerLap}>
                        //                 <option value="1">Onsite</option>
                        //                 <option value="2">Online</option>
                        //             </Form.Select>
                        //         </div>
                        //     </div>
                        //     <div className="row mb-3">
                        //         <label className="col-sm-2 col-form-label-sm">Pilih Jadwal</label>
                        //         <div className="col-sm-4">
                        //             <input type="date" className="col-sm-6 form-control-sm" name="tgl_verifikasi" />
                        //             <input type="time" className="col-sm-6 form-control-sm" name="jam_verifikasi" />
                        //         </div>
                        //     </div>
                        // </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => SavePenugasan(dataDisposisi)}>Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseAddPenugasan}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmPenugasan &&
                <SweetAlert
                    title="Proses Penugasan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickPenugasan}
                    onCancel={handleCloseConfirmPenugasan}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showPenugasanSuccess &&
                <SweetAlert
                    title="Penugasan Berhasil"
                    success
                    onConfirm={handleClickPenugasanSuccess}
                    btnSize="sm"
                />
            }
            {
                showPenugasanFailed &&
                <SweetAlert
                    title="Penugasan Gagal"
                    danger
                    onConfirm={handleClickPenugasanFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalSpp